
import { useDispatch } from "react-redux";
import { CDN_URL } from "../utils/constants";
import { addItem } from "../utils/cartSlice";

const ItemList = ({ items,/* dummy*/ }) => {

  const dispatch = useDispatch();

  const handleAddItem = (item) => {
    //Dispatch an action
    dispatch(addItem(item))
  } 

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div
        //   data-testid="foodItems"
          key={item.card.info.id}
          className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-200"
        >
          <img src={CDN_URL + item.card.info.imageId}
           className="w-20 h-20 object-cover rounded-md" />

          {/* Details section */}
            <div className="flex-1 mx-4">
            
              <h3 className="font-semibold text-gray-800">{item.card.info.name}</h3>
              <span className="text-sm text-gray-600 mt-1">
                - ₹
                {item.card.info.price
                  ? item.card.info.price / 100
                  : item.card.info.defaultPrice / 100}
              </span>
            
            <p className="text-xs text-gray-500 mt-1 line-clamp-2">{item.card.info.description}</p>
            </div>
        
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 transition-colors duration-300"
                // onClick={() => handleAddItem(item)}
                onClick={()=>handleAddItem(item)}
              >
                Add +
              </button>
        </div>
        
            
          
      ))}
    </div>
  );
};

export default ItemList;